module.exports = __webpack_public_path__ + "static/front/img/coundown_pro_img.2cf3440e.png";